import { Button, ScrollArea, Search } from '@ibsys/kit';
import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useHasPermission } from '@/entities/profile';
import { useDebouncedValue } from '@/shared/hooks';
import { EmployeeCard } from './EmployeeCard';
import { EmployeeList } from './EmployeeList';
import { MasterDetailLayout } from '@/shared/ui';

export const EmployeesPage: FC = () => {
  const { t } = useTranslation('employees');
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const canAdmin = useHasPermission('ADMIN_EMPLOYEE');

  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearchQuery = useDebouncedValue(searchQuery, 300);

  const handleSelectEmployee = useCallback(
    (employeeId: number) => {
      if (String(employeeId) === id) return;
      navigate(`/employees/${employeeId}`);
    },
    [id, navigate],
  );

  const handleCreate = () => {
    navigate('/employees/create');
  };

  const handleBack = () => {
    navigate('/employees');
  };

  return (
    <MasterDetailLayout
      isDetailOpen={Boolean(id)}
      onBack={handleBack}
      toolbar={
        <div className="flex items-center gap-4">
          <Search
            className="flex-1"
            placeholder={t('searchPlaceholder')}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {canAdmin && (
            <Button onClick={handleCreate} className="ml-auto">
              {t('addEmployee')}
            </Button>
          )}
        </div>
      }
      list={<EmployeeList selectedId={id} searchQuery={debouncedSearchQuery} onSelect={handleSelectEmployee} />}
      detail={
        <ScrollArea>
          <EmployeeCard employeeId={id} />
        </ScrollArea>
      }
    />
  );
};
